define('timezoneJS',['jquery', 'timezones/date'], function($) {
    timezoneJS.timezone.zoneFileBasePath = 'scripts/timezones/olson_data';
    timezoneJS.timezone.defaultZoneFile = ['northamerica'];
    timezoneJS.timezone.init({async : false});
    return timezoneJS;
});
